import { render } from "./ProjectOverviewList.vue?vue&type=template&id=9e0b90d2&scoped=true"
import script from "./ProjectOverviewList.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewList.vue?vue&type=script&lang=js"

import "./ProjectOverviewList.vue?vue&type=style&index=0&id=9e0b90d2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0b90d2"]])

export default __exports__